import { StyledCol, StyledOrangeGradTitle, StyledText } from '@/shared/styles';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

export const ScanIntroSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <StyledCol $gap={12} $align="center">
      <StyledOrangeGradTitle $size={isMobileOnly ? 20 : 32} $align="center">
        {t('free_tools.accessibility_checker.title')}
      </StyledOrangeGradTitle>
      <StyledText fontSize="20px" textAlign="center" width={isMobileOnly ? '100%' : '80%'}>
        {t('free_tools.accessibility_checker.content')}
      </StyledText>
    </StyledCol>
  );
};
